module.exports = __webpack_public_path__ + "908e4d2e/img/scraper-icon.df6ccde5.svg";